import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import PageTitle from "../../layouts/PageTitle";
import Swal from "sweetalert2";
import {
  addLanguage,
  getLanguageById,
  updateLanguage,
} from "../../../services/LanguageService";
import { Button } from "react-bootstrap";

const AddLanguage = () => {
  const [loading, setLoading] = useState(false);
  const [languageName, setLanguageName] = useState("");
  const hasFetched = useRef(false);
  const { id } = useParams();
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      const fetchLanguage = async () => {
        try {
          setLoading(true);
          const response = await getLanguageById(id);
          const language = response?.data;
          setLanguageName(language?.data?.name);
        } catch (err) {
          console.error("Error fetching language:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchLanguage();
    }
  }, [id]);

  const validateForm = () => {
    const newErrors = {};

    if (!languageName.trim()) {
      newErrors.languageName = "Title is required";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    try {
      // --- VALIDATE FORMS ---
      const formValid = validateForm();
      if (!formValid) {
        return;
      }
      const languageData = { name: languageName };

      setLoading(true);

      if (id) {
        // --- UPDATE EXISTING LANGUAGE ---
        await updateLanguage(id, languageData);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Language details updated successfully",
        });
        navigate("/language", {
          state: {
            page: location.state?.page || 1,
            searchTerm: location.state?.searchTerm || "",
          },
        });
      } else {
        // --- CREATE NEW LANGUAGE ---
        const response = await addLanguage(languageData);
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Language added successfully",
          });
          navigate("/language", {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
            },
          });
        }
      }
    } catch (err) {
      console.error("Error in handleSave:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Operation failed",
      });
    } finally {
      // hide loader
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu={`${id ? "Edit Language" : "Add Language"}`}
        motherMenu="Language"
        activeMenuLink={`${id ? `edit-language/${id}` : "add-language"}`}
        motherMenuLink={"language"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form>
                    <div
                      onClick={() => {
                        navigate("/language", {
                          state: {
                            page: location.state?.page || 1,
                            searchTerm: location.state?.searchTerm || "",
                          },
                        });
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>Language List</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <input
                        type="text"
                        className="form-control w-full"
                        placeholder="Title"
                        value={languageName}
                        onChange={(e) => setLanguageName(e.target.value)}
                      />
                      {errors.languageName && (
                        <div className="text-danger mt-1">
                          {errors.languageName}
                        </div>
                      )}{" "}
                    </div>
                  </form>
                </div>
              </div>
              <hr style={{ margin: "0px" }} className="mx-2" />
              <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                <Button
                  type="button"
                  variant="secondary"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    navigate("/language", {
                      state: {
                        page: location.state?.page || 1,
                        searchTerm: location.state?.searchTerm || "",
                      },
                    })
                  }}
                >
                  Back
                </Button>

                {/* Save / Update Button */}
                <Button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleSave}
                >
                  {id ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLanguage;
